<template>
    <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 69.28"
            :class="twClass"
    >
        <g id="Icon_ionic-ios-qr-scanner">
            <path
                    d="m24.09,20.79h-4.24c-2.68,0-4.85,2.17-4.85,4.85v4.24c-.02.56.42,1.02.98,1.04.56.02,1.02-.42,1.04-.98,0-.02,0-.04,0-.06v-4.31c.03-.72.33-1.39.84-1.89.5-.53,1.18-.84,1.91-.86h4.31c.56.02,1.02-.42,1.04-.98.02-.56-.42-1.02-.98-1.04-.02,0-.04,0-.06,0h0Z"
            />
            <path
                    d="m40.22,20.79h-4.31c-.56-.02-1.02.42-1.04.98-.02.56.42,1.02.98,1.04.02,0,.04,0,.06,0h4.31c.73.02,1.41.34,1.91.86.52.5.82,1.17.84,1.89v4.31c-.02.56.42,1.02.98,1.04s1.02-.42,1.04-.98c0-.02,0-.04,0-.06v-4.31c0-2.64-2.14-4.77-4.77-4.77Z"
            />
            <path
                    d="m24.09,46.46h-4.31c-.73-.02-1.41-.34-1.91-.86-.52-.5-.82-1.17-.84-1.89v-4.31c-.02-.56-.48-1-1.04-.98-.53.02-.96.44-.98.98v4.31c0,2.64,2.14,4.77,4.77,4.77h4.31c.56.02,1.02-.42,1.04-.98.02-.56-.42-1.02-.98-1.04-.02,0-.04,0-.06,0h0Z"
            />
            <path
                    d="m43.99,38.39c-.56,0-1.01.45-1.01,1.01v4.31c-.09,1.48-1.27,2.67-2.76,2.75h-4.31c-.56-.02-1.02.42-1.04.98s.42,1.02.98,1.04c.02,0,.04,0,.06,0h4.24c2.68,0,4.84-2.17,4.85-4.85v-4.24c0-.56-.45-1.01-1.01-1.01Z"
            />
        </g>
        <path
                d="m29.52,27.59l-5.9,2.21c-.53.2-.88.71-.88,1.27v6.39c0,.52.29.99.75,1.22l5.9,2.95c.38.19.83.19,1.22,0l5.9-2.95c.46-.23.75-.7.75-1.22v-6.39c0-.57-.35-1.07-.88-1.27l-5.9-2.21c-.31-.12-.65-.12-.96,0Zm.48,1.76l5.45,2.04v.03l-5.45,2.21-5.45-2.21v-.03l5.45-2.04Zm.91,10.1v-4.23l4.54-1.84v3.8l-4.54,2.27Z"
        />
    </svg>
</template>

<script setup lang="ts">
const {twClass = 'w-6 h-6 stroke-1 stroke-primary'} = defineProps<{ twClass?: string }>();
</script>
